import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ElementRef
} from '@angular/core';
import { OktaAuthModule } from '@okta/okta-angular';
import { HttpClientModule } from '@angular/common/http';

import { OktaService } from '../../../../ui-components/src/services/okta.service';

@Component({
  selector: 'okta-login',
  imports: [HttpClientModule],
  templateUrl: './okta-login.component.html',
  styleUrl: './okta-login.component.scss',
  standalone: true
})
export class OktaLoginComponent implements OnInit {
  @Output() isIntersecting = new EventEmitter<boolean>();
  private observer: IntersectionObserver | null = null;

  constructor(
    public oktaAuth: OktaAuthModule,
    public oktaService: OktaService,
    private _el: ElementRef,
  ) {}

  async ngOnInit() {
    this._watchElementForEntry();
  }

  private _watchElementForEntry(): void {
    const options: IntersectionObserverInit = {
      root: null, // defaults to the browser viewport
      rootMargin: '0px',
      threshold: 0.1, // trigger when 10% of the element is visible
    };

    const callback = (entries: IntersectionObserverEntry[]): void => {
      entries.forEach(entry => {
        this.isIntersecting.emit(entry.isIntersecting);

        if (entry.isIntersecting) {
          this.loginWithRedirect();
          this.observer?.unobserve(entry.target);
        }
      });
    };

    this.observer = new IntersectionObserver(callback, options);
    this.observer.observe(this._el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect(); // clean up the observer to prevent memory leaks
    }
  }
  loginWithRedirect() {
    if (this.oktaService.getIsAuthenticated()) {
      window.location.href = this.oktaService.getRedirectUrl();
    }
    return;
  }
}